import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Card, Col, Form, Input, Row, Table } from 'antd';
import { queryAnnouncementList } from '@api/administrative/announcement';
import { connect } from 'react-redux';
import { setBackInfo } from '@store/modules/back_info';
import moment from 'moment';

const FormItem = Form.Item;

const typeName = ['公司公告', '业务动态'];

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      total: 0,
      pageNo: 1,
      isPermission: false,
    };
  }

  componentDidMount() {
    this.loadData(1);
    this.judge(this.props.account_info);
  }

  componentWillUnmount() {
    const { pageNo, condition } = this.state;
    const params = {
      pageNo,
      condition,
    };
    this.props.dispatch(setBackInfo(params));
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.account_info !== nextProps.account_info) {
      this.judge(nextProps.account_info);
    }
  }

  // 加载需公告列表数据
  loadData = pageNo => {
    const params = {};
    const { condition } = this.state;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    params.condition = condition || '';
    this.setState({
      pageNo: current,
      isLoading: true,
    });
    queryAnnouncementList(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
          total: res.totalSize,
          isLoading: false,
        });
      }
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    const { pageNo } = this.state;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState(
          {
            condition: values.condition,
          },
          () => {
            this.loadData(pageNo);
          },
        );
      }
    });
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { condition } = this.state;
    return (
      <div>
        <Form layout="inline" onSubmit={this.handleSubmit} style={{ textAlign: 'right' }}>
          <FormItem>
            {getFieldDecorator('condition', {
              initialValue: condition || null,
            })(<Input placeholder="请输入关键字" />)}
          </FormItem>
          <FormItem>
            <Button htmlType="submit">查询</Button>
          </FormItem>
        </Form>
      </div>
    );
  };

  judge = accountInfo => {
    const role = accountInfo.roles;
    let isPermission = false;
    role.forEach(sign => {
      if (sign === '[XZManager]' || sign === '[HRVP]' || sign === '[HrManager]') {
        isPermission = true;
      }
    });
    if (accountInfo.admin) {
      isPermission = true;
    }

    this.setState({
      isPermission,
    });
  };

  columns = () => {
    return [
      {
        title: '标题',
        dataIndex: 'title',
        render: (text, record) => {
          return <Link to={`/administrative/announcement/edit/${record.uuid}`}>{text}</Link>;
        },
      },
      {
        title: '类型',
        dataIndex: 'type',
        render: text => {
          return <span>{typeName[text]}</span>;
        },
      },
      {
        title: '更新时间',
        dataIndex: 'updateTime',
        render: text => {
          return <span>{moment.unix(text / 1000).format('YYYY-MM-DD HH:mm:ss')}</span>;
        },
      },
      {
        title: '操作',
        render: (text, record) => {
          const { isPermission } = this.state;
          return (
            <span>
              <Link to={`/administrative/announcement/open/${record.uuid}`}>查看</Link>
              {isPermission ? <span className="ant-divider" /> : null}
              {isPermission ? (
                <Link to={`/administrative/announcement/edit/${record.uuid}`}>编辑</Link>
              ) : null}
            </span>
          );
        },
      },
    ];
  };

  render() {
    const { data, isLoading, total, pageNo, isPermission } = this.state;
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: pageNo,
      onChange: current => {
        this.loadData(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <Card>
        <div className="tableList">
          <Row style={{ paddingBottom: '20px' }}>
            <Col span={13}>
              {isPermission ? (
                <Link to="/administrative/announcement/add">
                  <Button type="primary">添加</Button>
                </Link>
              ) : null}
            </Col>

            <Col span={11}>
              <div className="tableListForm">{this.renderSearchForm()}</div>
            </Col>
          </Row>
        </div>
        <Table
          rowKey="uuid"
          loading={isLoading}
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
        />
      </Card>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
  account_info: state.account_info,
}))(Form.create({ wrappedComponentRef: true })(Index));



// WEBPACK FOOTER //
// ./src/components/administrative/announcement/Index.js